<div *ngIf="isLoader" class="svg-loader"></div>
<div class="">
  <button type="button" class="close cancelBtn" aria-label="Close" mat-dialog-close (click)="onCancelClick()">
    Close
  </button>
</div>
<div class="modelTitle heading2 alignCenter">
  {{Heading}}
</div>

<ng-container *ngIf="errFlag">
  <div class="text-danger fz-16">{{errMsg}}</div>
</ng-container>
<div class="tagFormContainer dropdown-height">
  <form #tagForm="ngForm" novalidate>
    <div class="pl-4 pr-4">
      <div class="row px-5 pt-2">
        <div class="col-sm-12 pad-lr">
          <div class="row mb-3 mx-3">
            <div class="col-sm-2">
              <span class="form-label">Tag ID<span class="text-danger star-danger">*</span></span>
              <span matTooltip="Tag Id should be as stored in OSI PI" matTooltipPosition="right"
                    matTooltipclass="tooltip"><mat-icon class="help-icon float-right">help_outline</mat-icon></span>
            </div>
            <div class="col-sm-10 pl-2">
                <input disabled type="text" class="form-control" [attr.data-value]="data.tagId" 
                       required name="tagId" [(ngModel)]="data.tagId" #tagId="ngModel" tabindex="0"
                       autocomplete="off">
                <span class="text-danger" *ngIf="tagId.invalid && tagId.touched">
                  Tag Id is required.
                </span>
                <div class="text-danger" *ngIf="tagAvailable == true">
                  Tag Id is already available.
                </div>
                <div class="text-danger" *ngIf="tagExistInPiPointFlag == true">
                  Tag id does not exist in PI Point.
                </div>
              </div>

          </div>
          <div class="row">
            <div class="col-sm-6 division pad-lr">
              <div class="row mb-3">
                <div class="col-sm-4">
                  <label for="locationId" class="form-label">Location<span class="text-danger star-danger">*</span></label>
                </div>
                <div class="col-sm-8">
                  <ng-container *ngIf="!editDisabled">
                    <input id="locationId" disabled type="text" class="form-control" required name="locationId" ngModel #locationId="ngModel"
                      [(ngModel)]="data.locationName" [typeahead]="locationList"
                      [typeaheadOptionField]="'locationName'" [attr.data-value]="data.locationId"
                      (typeaheadOnSelect)="locationChange($event)" (focusout)="locationKeyUp(locationId)"
                      placeholder="Enter Location" [typeaheadOptionsLimit]="5" autocomplete="off">
                    <span class="text-danger"
                      *ngIf="((locationId.invalid && locationId.touched) || locationFlag == true)">
                      Please provide valid location
                    </span>
                  </ng-container>
                  <ng-container *ngIf="editDisabled">
                    <input type="text" [attr.data-value]="disabledLoc" name="disabledLoc" class="form-control"
                      [(ngModel)]="disabledLoc" disabled>
                  </ng-container>
                </div>
              </div>
             
              <div class="row mb-3">
                <div class="col-sm-4">
                  <span class="form-label">Tag Description</span>
                </div>
                <div class="col-sm-8">
                  <ng-container *ngIf="data.action != 'View'">
                    <textarea  [attr.data-value]="data.tagDesc" type="text"
                      class="form-control" tabindex="0" disabled maxlength="150" name="tagDesc"
                      [(ngModel)]="data.tagDesc" #tagDesc="ngModel"></textarea>
                    <span class="text-danger" *ngIf="tagDesc.invalid && tagDesc.touched">
                      Tag Description is required
                    </span>
                  </ng-container>
                  <ng-container *ngIf="data.action == 'View'">
                    <textarea disabled [attr.data-value]="data.tagDesc" placeholder="Allowed 150 characters only"
                      type="text" class="form-control" tabindex="0" required maxlength="150" name="disTagDesc"
                      [(ngModel)]="data.tagDesc" #tagDesc="ngModel"></textarea>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="col-sm-6 pad-lr">
              <div class="row mb-3">
                <div class="col-sm-4">
                  <label class="form-label" for="engUnits">Engineering Units</label>
                </div>
                <div class="col-sm-8">
                  <input type="text" class="form-control" disabled autocomplete="off" [attr.data-value]="data.engUnits"
                    tabindex="0" id="engUnits" name="engUnits" [(ngModel)]="data.engUnits"
                    #engUnits="ngModel">
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-4">
                  <label for="UseCaseToTags" class="form-label">Use Case<span class="text-danger star-danger">*</span></label>
                </div>
                <div class="col-sm-8">
                  <ng-container *ngIf="data.action == 'Create' || data.action == undefined">
                    <ng-multiselect-dropdown name="UseCaseToTags" [settings]="dropdownSettings" [data]="useCaseList"
                      [(ngModel)]="data.UseCaseToTags" [attr.data-value]="data.UseCaseToTags" required>
                    </ng-multiselect-dropdown>
                  </ng-container>
                  <ng-container *ngIf="data.action == 'update'">
                    <ng-multiselect-dropdown name="UseCaseToTags" [settings]="dropdownSettings" [data]="useCaseList"
                      [(ngModel)]="data.UseCaseToTags" required [attr.data-value]="data.UseCaseToTags"
                      >
                    </ng-multiselect-dropdown>
                  </ng-container>
                  <ng-container *ngIf="data.action == 'View'">
                    <ng-multiselect-dropdown name="UseCaseToTags" [settings]="dropdownSettings" [data]="useCaseList"
                      [(ngModel)]="data.UseCaseToTags" required [attr.data-value]="data.UseCaseToTags"
                      [disabled]="data.action == 'View'">
                    </ng-multiselect-dropdown>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 mb-5 ml-1" *ngIf="data.action !='View'">
        <div class="col-sm-12 text-center">
          <ng-container *ngIf="!editDisabled">
            <button class="btn btn-primary mr5"
              [disabled]="!tagForm.valid || locationFlag || tagExistInPiPointFlag"
              (click)="createTag(tagForm)" tabindex="0">SAVE</button>
          </ng-container>
          <button class="btn btn-primary mr5" [disabled]="!tagForm.valid" *ngIf="editDisabled" (click)="updateTag()" tabindex="0">SAVE</button>
          <button class="btn btn-primary" (click)="onCancelClick()">CANCEL</button>
        </div>
      </div>

    </div>
  </form>
</div>

<div class="widgetContainer" *ngIf="isLoader==true">
  <div class="loader"></div>
</div>
